var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgControlQualityGrammarCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18036_5251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.47 3.15332L0 3.17332V48H2V5.16999L9.47667 5.15332L9.47 3.15332Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.55 3.11011L21.8833 3.12677V5.12677L31.14 5.11011V20.5034H46V48.0001H48V18.5634L32.55 3.11011ZM33.1333 6.52344L45.1133 18.5034H33.1333V6.52344Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2467 27.1667H10.0001V29.8334H4.63672V31.8334H10.0001V34.5001H21.2467V31.8334H43.3067V29.8334H21.2467V27.1667ZM12.0001 29.1667H19.2467V29.8334H12.0001V29.1667ZM19.2434 32.4734H12.0001V31.8067H19.2467L19.2434 32.4734Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8667 40.6667H13.3767V43.3334H4.63672V45.3334H13.3767V48.0001H26.8667V45.3334H43.3067V43.3334H26.8667V40.6667ZM15.3767 42.6667H24.8667V43.3334H15.3767V42.6667ZM24.8667 45.9734H15.3767V45.3067H24.8667V45.9734Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0001 33.9434H31.3634V36.61H4.63672V38.61H31.3634V41.2767H37.0001V38.61H43.3334V36.61H37.0001V33.9434ZM33.3801 35.9434H35.0001V36.61H33.3801V35.9434ZM35.0001 39.25H33.3801V38.5834H35.0001V39.25Z",
    fill: "#415385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2668 19.7133C11.3065 19.9487 11.4292 20.1621 11.6126 20.315C11.796 20.4678 12.028 20.55 12.2668 20.5467H13.6001V23.2133L17.6668 25.2467V20.5467H19.0001C19.2388 20.55 19.4708 20.4678 19.6542 20.315C19.8376 20.1621 19.9603 19.9487 20.0001 19.7133L20.5468 16.3333C20.5518 16.2657 20.5518 16.1977 20.5468 16.13L20.0001 0.963334C19.9906 0.704524 19.8811 0.459491 19.6945 0.279813C19.508 0.100135 19.2591 -0.000173925 19.0001 2.26385e-07H12.2534C11.9944 -0.000173925 11.7455 0.100135 11.559 0.279813C11.3724 0.459491 11.2629 0.704524 11.2534 0.963334L10.6901 16.1367C10.685 16.2043 10.685 16.2723 10.6901 16.34L11.2668 19.7133ZM15.8334 22.28L15.4168 22.0733V21.3067H15.8334V22.28ZM18.1668 18.5467H13.1001L12.8701 17.1767H18.3801L18.1668 18.5467ZM13.2168 2H18.0334L18.5201 15.1767H12.7301L13.2168 2Z",
    fill: "#415385"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18036_5251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgControlQualityGrammarCheck);
export default __webpack_public_path__ + "static/media/control-quality-grammar-check.d940a69b01e48878a103ea92425ea306.svg";
export { ForwardRef as ReactComponent };